import { render, staticRenderFns } from "./ocrUpdDialog.vue?vue&type=template&id=a56c748c&scoped=true"
import script from "./ocrUpdDialog.vue?vue&type=script&lang=js"
export * from "./ocrUpdDialog.vue?vue&type=script&lang=js"
import style0 from "./ocrUpdDialog.vue?vue&type=style&index=0&id=a56c748c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56c748c",
  null
  
)

export default component.exports